import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '~/index.css';
import '~/i18n.ts';
import { RouterProvider } from 'react-router';
import { router } from '~/router.tsx';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { Toaster } from 'react-hot-toast';
// @ts-ignore
import '@fontsource-variable/inter';

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
        <Toaster position="top-center" />
      </QueryClientProvider>
    </Provider>
  </StrictMode>
);
